import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'totalizarCampo'
})
export class TotalizarCampoPipe implements PipeTransform {

  transform(items: any[], field: string): number {
    if (!items || !field) {
      return 0;
    }
    return items.reduce((acc, item) => acc + (item[field] || 0), 0);
  }

}
